// Full-document render of the sealy HTML sitemap (/cms/sitemap/):
// PageSkeleton wrapping the sitemap body.
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { SiteMapPageBody } from "../components/SiteMapPageBody";

// Mutable reactivated props (not Immutable<>): this template composes
// PageSkeleton, which is typed with mutable reactivated props (see
// PageSkeleton).
export const Template = (
    props: templates.SiteMapDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <SiteMapPageBody entries={props.entries} />
    </PageSkeleton>
);
